import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import IconRaw from "module-common/Icon";

export default class Approver extends Component {
  static propTypes = {
    name: PropTypes.string,
    onRemove: PropTypes.func
  };

  render() {
    return (
      <Wrapper>
        {this.props.name}
        <Icon
          name="x-button"
          width={8}
          height={8}
          onClick={this.props.onRemove}
        />
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 0 4px;
  color: ${props => props.theme.blueButton};
  background-color: ${props => props.theme.blueHighlight};
  margin-right: 6px;
  border-radius: 3px;
`;
const Icon = styled(IconRaw) `
  margin-left: 6px;
`;



// WEBPACK FOOTER //
// ./src/module-case-management/content-panel/footer/Approver.js